import { NavBarSubList } from './nav-bar-sub-list'
import { ListItem, useTheme } from '@mui/material'
import { NavLink } from 'components/nav-link'
import { ICategory } from 'api/types/category'
import { useMatch } from 'react-router-dom'
import { pageConfig } from 'app/page-config'

type Props = {
  category: ICategory
  isOpen: boolean
  onOpen: (id: string) => void
  onClose: () => void
}

export const NavBarItem = ({ category, isOpen, onOpen, onClose }: Props) => {
  const theme = useTheme()
  const { id, name, subCategories } = category
  const to = `${pageConfig.products}/${id}`
  const match = useMatch({
    path: to,
    end: to.length === 1,
  })

  return (
    <ListItem
      onMouseEnter={() => onOpen(id)}
      onMouseLeave={onClose}
      sx={{
        width: 'auto',
        display: 'flex',
        flexGrow: 1,
        cursor: 'pointer',
        background: match
          ? theme.palette.primary.main
          : 'linear-gradient(0deg, rgba(118,191,41,1) 50%, rgba(150,244,50,1) 100%)',
        borderTop: `1px solid ${
          match ? theme.palette.primary.main : 'rgba(118, 191, 41, 1)'
        }`,
        borderBottom: `1px solid ${
          match ? theme.palette.primary.main : 'rgba(118, 191, 41, 1)'
        }`,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        '&:first-of-type': {
          borderLeft: `1px solid ${
            match ? theme.palette.primary.main : 'rgba(118, 191, 41, 1)'
          }`,
          borderBottomLeftRadius: theme.shape.borderRadius,
        },
        '&:last-of-type': {
          borderRight: `1px solid ${
            match ? theme.palette.primary.main : 'rgba(118, 191, 41, 1)'
          }`,
          borderBottomRightRadius: theme.shape.borderRadius,
        },
        '&:not(:first-of-type)': {
          borderLeft: '1px solid rgba(0, 0, 0, 0.22)',
        },
        '&:not(:last-of-type)': {
          borderRight: '1px solid rgba(255, 255, 255, 0.3);',
        },
        '&:hover': {
          background: theme.palette.primary.main,
          borderTopColor: theme.palette.primary.main,
          borderBottomColor: theme.palette.primary.main,
        },
        '&:hover:first-of-type': {
          borderLeftColor: theme.palette.primary.main,
          borderBottomLeftRadius: 0,
        },
        '&:hover:last-of-type': {
          borderRightColor: theme.palette.primary.main,
          borderBottomRightRadius: 0,
        },
        '&:hover::after': {
          content: '""',
          position: 'absolute',
          bottom: '2px',
          right: '-15px',
          width: '19px',
          height: '15px',
          transform: 'rotate(60deg)',
          background: 'transparent',
          borderRadius: '50%',
          boxShadow: `-1px 4px 0 ${theme.palette.primary.main}`,
          zIndex: 1,
          pointerEvents: 'none',
        },
      }}
    >
      <NavLink
        to={to}
        styles={{
          color: theme.palette.common.white,
          fontWeight: 700,
          lineHeight: '18px',
          fontSize: '12px',
          textAlign: 'center',
          padding: '2px 6px',
        }}
      >
        {name}
      </NavLink>
      {isOpen && (
        <NavBarSubList
          categoryId={id}
          subCategories={subCategories}
          onClose={onClose}
        />
      )}
    </ListItem>
  )
}
